export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/nodejs-service-stack-form';
